import React from "react";
import Icon, { IconProps } from "./Icon";

export function Gift({ viewBox = "0 0 16 16", color = "currentColor", ...iconProps }: IconProps) {
  return (
    <Icon {...iconProps} fill="none" viewBox={viewBox}>
      <path
        stroke={color}
        strokeLinejoin="round"
        strokeOpacity="0.7"
        strokeWidth="1.5"
        d="M8 5.167V4.056m0 1.11H6.889a2.22 2.22 0 0 1-2.222-2.222c0-.613.497-1.11 1.11-1.11C7.006 1.833 8 2.827 8 4.055m0 1.11h1.111a2.22 2.22 0 0 0 2.222-2.222c0-.613-.497-1.11-1.11-1.11A2.22 2.22 0 0 0 8 4.055m0 1.11H3.167a.667.667 0 0 0-.667.667v1.5c0 .369.298.667.667.667M8 5.167h4.833c.368 0 .667.298.667.666v1.5a.667.667 0 0 1-.667.667M8 5.167V8m0 5.5H3.833a.667.667 0 0 1-.666-.667V8M8 13.5h4.167a.667.667 0 0 0 .666-.667V8M8 13.5V8m0 0h4.833M8 8H3.167m0-.333V8m9.666 0v-.333"
      ></path>
    </Icon>
  );
}
